/** Shared visual tokens for both administration workspaces. */
export const adminTokens = {
  canvas: '#F7F7F8',
  surface: '#FFFFFF',
  ink: '#202024',
  muted: '#68686F',
  border: '#E4E4E7',
  accent: '#000000',
  accentDark: '#000000',
  accentLight: '#333333',
  selected: '#0000000A',
  font: '"Helvetica Neue", "Noto Sans KR", sans-serif',
  radius: 2,
} as const;
